/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, Transition } from '@headlessui/react';
import toast from 'react-hot-toast';
import * as actions from '../store/actions';
import { StoreService } from '../services';
import { copy, formatAmount, getAdminCountryEquivalent, onlyRifChars, toAmount } from '../utils/parse';
import DeliveryIcon from '../assets/images/delivery.png';
import PickUpIcon from '../assets/images/pick-up.png';
import DefaultPhoto from '../assets/images/photo.png';

const SELL_TYPES = {
  NORMAL: 1,
  SIZE_COLORS: 2
}

const DECIMAL_STOCK = {
  YES: 1,
  NO: 0,
}

const Checkout = ({ onClose, show_prices, sizes, colors, admin_id, country_id, decimals }) => {
  const cart = useSelector(state => state.cart).filter(x => x.admin_id === admin_id);
  const dispatchTypes = useSelector(state => state.dispatchTypes);
  const dispatch = useDispatch();
  
  const [loading, setLoading] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [form, setForm] = useState({
    name: '',
    code: '+58',
    tlf: '',
    dispatch: null,
    errorName: false,
    errorPhone: false,
    errorDocument: false,
    errorAddress: false,
    errorDispatch: false,
    errorShippingAddress: false,
    note: '',
    document: '',
    address: '',
    shipping_address: ''
  });
  const isDelivery = String(dispatchTypes.find(x => x.value === form.dispatch)?.label).toLowerCase() === 'delivery';

  const getDiscounts = async () => {
    setLoading(true);
		try {
			const data = await StoreService.getAdminNewDiscounts({ user_id: admin_id, all: true });
			if (data && data.data.discounts) setDiscounts(data.data.discounts);

		} catch (error) {
			console.error('Error al obtener los descuentos', error);
		}
    setLoading(false);
  }

  const { tempCart, totals } = useMemo(() => {
    const tempCart = [];
    const totals = {
      subtotal_original: 0,
      subtotal: 0,
      total: 0,
      discount: 0,
    };

		const cartProductIds = cart.map(item => item.product_id);

		// ---------------------------------------------------------
		// 2. CÁLCULO LÍNEA POR LÍNEA
		// ---------------------------------------------------------
		for (const product of copy(cart)) {
			const prodId = product.id;
			const qty = product?.decimal_stock === DECIMAL_STOCK.YES ? parseFloat(product.quantity) : parseInt(product.quantity);

			// Obtener el precio por defecto a comparar. Para SIZE_COLOR, buscar el de la variante específica
			let defaultPriceToCompare = product.default_price_value;
			if (product.type === SELL_TYPES.SIZE_COLORS && product.size_colors) {
				const size_color = product.size_colors.find(i =>
					(product.size_id && product.color_id && i.size_id === product.size_id && i.color_id === product.color_id) ||
					(product.size_id && !product.color_id && i.size_id === product.size_id && !i.color_id) ||
					(product.color_id && !product.size_id && i.color_id === product.color_id && !i.size_id)
				);
				if (size_color && size_color.sale_price != null) {
					defaultPriceToCompare = size_color.sale_price;
          product.sale_price = toAmount(size_color.sale_price, decimals);
          product.originalPrice = toAmount(size_color.sale_price, decimals);
          product.subtotal_original = toAmount(qty * product.originalPrice, decimals);
				}
        product.size_color = size_color;
			}

			const originalPrice = parseFloat(product.sale_price || product.price);
			product.subtotal_original = toAmount(qty * originalPrice, decimals);
			totals.subtotal_original += product.subtotal_original;

			let appliedPrice = originalPrice;
			let itemPercentageDiscount = 0;
			let applied_rules = []; // Seguimiento de descuentos por producto
			const isDefaultPrice = defaultPriceToCompare == null || parseFloat(originalPrice) === parseFloat(defaultPriceToCompare);

			// EVALUAR REGLAS POR PRODUCTO
			if (discounts && discounts.length > 0 && isDefaultPrice) {
				let allApplicableVolumenRules = [];

				discounts.forEach(master => {
					if (master.status !== 1) return;

					master.discount_details.forEach(rule => {
						// Por Volumen
						if (master.type === 'volumen') {
							if ((rule.product_id === prodId || (rule.category_id && rule.category_id === product.category_id)) && qty >= rule.min_quantity) {
								allApplicableVolumenRules.push({ rule, master });
							}
						}

						// Por Surtido
						if (master.type === 'surtido' && rule.product_id === prodId) {
							let distinctCount = 0;
							master.discount_details.forEach(surtidoRule => {
								if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
							});

							if (distinctCount >= rule.min_quantity) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
							}
						}
					});
				});

				if (allApplicableVolumenRules.length > 0) {
					const categoryRules = allApplicableVolumenRules.filter(item => item.rule.category_id && item.rule.category_id === product.category_id);
					const rulesToApply = categoryRules.length > 0 ? categoryRules : allApplicableVolumenRules;

					rulesToApply.forEach(item => {
						itemPercentageDiscount += parseFloat(item.rule.percentage);
						applied_rules.push({ discount_id: item.master.id, name: item.master.name, percentage: parseFloat(item.rule.percentage) });
					});
				}
			}

			if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

			// Asegurarnos de tener el manual_discount guardado la primera vez
			if (product.manual_discount === undefined) {
				product.manual_discount = Number(product.discount || 0);
			}

			// Aplicar descuentos en cascada sobre el precio aplicado
			let finalUnitPrice = appliedPrice;

			// 2. Aplicar descuento automático de reglas (volumen, ruta, etc)
			if (itemPercentageDiscount > 0) {
				finalUnitPrice -= (finalUnitPrice * (itemPercentageDiscount / 100));
			}

			if (finalUnitPrice < 0) finalUnitPrice = 0;

			product.selected_price = appliedPrice;

			// Mostrar visualmente los descuentos aplicados
			if (itemPercentageDiscount > 0) {
				product.discount = itemPercentageDiscount;
			} else {
				product.discount = 0;
			}

			product.applied_discounts = applied_rules;

			const lineOriginalSubtotal = qty * originalPrice;
			const lineFinalSubtotal = qty * finalUnitPrice;

      product.originalPrice = toAmount(originalPrice, decimals);
      product.finalPrice = toAmount(finalUnitPrice, decimals);
			totals.subtotal_original += toAmount(lineOriginalSubtotal, decimals);
			product.total = toAmount(lineFinalSubtotal, decimals);
			totals.total += product.total;

      tempCart.push(product);
		}

		let currentSubtotal = totals.subtotal;
		if (currentSubtotal < 0) currentSubtotal = 0;

    return { tempCart, totals };
  }, [cart, discounts]);

  const onSubmit = () => {
    if (!tempCart.length) {
      toast.error('Debe agregar algún producto al carrito');
      return onClose();
    }

    if (!form.name) {
      toast.error('Debe indicar su nombre');
      return setForm({ ...form, errorName: true });
    }

    if (form.tlf.length < 10) {
      toast.error('Verifique el número de teléfono');
      return setForm({ ...form, errorPhone: true });
    }

    if (form.document.length <= 0) {
      toast.error('Verifique el número de documento');
      return setForm({ ...form, errorDocument: true });
    }

    if (form.address.length <= 0) {
      toast.error('Verifique la dirección física del pedido');
      return setForm({ ...form, errorAddress: true });
    }

    const _dispatchType = dispatchTypes.find(x => x.value === form.dispatch);
    const dispatchType = _dispatchType?.label;

    if (!dispatchType) {
      toast.error('Debe seleccionar la forma de despacho');
      return setForm({ ...form, errorDispatch: true });
    }

    if (isDelivery && !form.shipping_address) {
      toast.error('Debe indicar la dirección de envío');
      return setForm({ ...form, errorShippingAddress: true });
    }

    setLoading(true);

    StoreService.confirm({
      ...form,
      admin_id,
      products: tempCart.map(item => ({
        ...item,
        photo: null,
        photos: null,
        prices: null,
        size_color: null,
        size_colors: null,
        ...(item.selected_price !== undefined && { selected_price: item.selected_price }) // Agrega selected_price solo si existe
      })),      
    })
      .then(async res => {
        if (res.data?.error) return toast.error(res.data.error);

        let total = 0;
        for (const product of res.data.message) {
          total = toAmount(total + product.precio * product.cantidad, decimals);
        }

        let message = `Nombre: ${form.name}\n`;
        message += `Teléfono: ${form.tlf}\n`;
        message += `${getAdminCountryEquivalent(country_id).bothDni}: ${form.document}\n`;
        message += `Dirección física: ${form.address}\n`;
        message += `Nota: ${form.note}\n`;
        message += `Forma de despacho: ${dispatchType}\n`;
        message += isDelivery ? `Dirección de envío: ${form.shipping_address}\n\n` : `\n`;
        if (show_prices)
          message += res.data.message.map(x => {
            if (x.product.type == SELL_TYPES.NORMAL)
              return `${x.cantidad}x ${x.producto}, *${ formatAmount(x.precio, decimals) }*`;
            else {
              const size = sizes.find(i => i.id == x.size_id);
              const color = colors.find(i => i.id == x.color_id);
              return `${x.cantidad}x ${x.producto}, *${ formatAmount(x.precio, decimals) }*, (${ [size?.name,color?.name].filter(i => i != null).join(',') })`;
            }
          }).join('\n');
        else
          message += res.data.message.map(x => {
            if (x.product.type == SELL_TYPES.NORMAL)
              return `${x.cantidad}x ${x.producto}`;
            else {
              const size = sizes.find(i => i.id == x.size_id);
              const color = colors.find(i => i.id == x.color_id);
              return `${x.cantidad}x ${x.producto}, (${ [size?.name,color?.name].filter(i => i != null).join(',') })`;
            }
          }).join('\n');
        if (show_prices)
          message += `\n\n*Total: ${formatAmount(total, decimals)}*`;

        message = encodeURIComponent(message);

        const url = `https://api.whatsapp.com/send/?phone=${res.data.contact}&text=${message}&type=phone_number&app_absent=0`;
        window.open(url);

        await StoreService.save({
          name: form.name,
          notes: form.note,
          dispatch_id: _dispatchType?.value,
          phone: form.tlf,
          document: form.document,
          address: form.address,
          admin_id,
          shipping_address: isDelivery ? form.shipping_address : undefined,
          details: tempCart.map(item => ({
            ...item,
            photo: null,
            photos: null,
            prices: null,
            size_color: null,
            size_colors: null,
            product_id: item.id,
            quantity: item.quantity,
            size_id: item.size_id,
            color_id: item.color_id,
            ...(item.selected_price !== undefined && { selected_price: item.selected_price }) // Agrega selected_price solo si existe
          })),          
        });

        dispatch(actions.clearCart());
        onClose();
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getDiscounts();
  }, []);

  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl xl:max-w-3xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                  <Dialog.Title as="h3" className="text-xl font-medium leading-6 p-6 pb-2 text-black flex flex-row">
                    <div onClick={() => onClose()} className="cursor-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12Z" />
                      </svg>
                    </div>
                    <span className="ml-4 font-bold">Resumen del Pedido</span>
                  </Dialog.Title>

                  <div className="cart-wrapper">
                    <div className="border-r products">
                      {tempCart.map((product,index) => {
                        const size_color = product?.size_color;

                        const enoughStock = (product) => {
                          let stock = product.type === SELL_TYPES.SIZE_COLORS
                            ? (size_color?.stock || 0)
                            : product.stock;

                          if(product?.decimal_stock == DECIMAL_STOCK.NO){
                            stock = parseInt(stock)
                          }

                          if (stock < product.quantity) {
                            toast(`No hay stock suficiente (quedan ${stock})`, { icon: '⚠' });
                            return false;
                          }
                          return true;
                        }

                        const onUpdate = (more = true) => {
                          const newProd = { ...product };

                          if (more) {
                            const qty = Number(parseFloat(newProd.quantity).toFixed(2)) + 1
                            newProd.quantity = qty;
                          } else if (newProd.quantity > 1) {
                            const qty = Number(parseFloat(newProd.quantity).toFixed(2)) - 1
                            newProd.quantity = qty;
                          } else {
                            return;
                          }

                          if (!enoughStock(newProd)) return;
                          dispatch(actions.updateCartProduct(newProd));
                        }

                        const onChangeManual = (value) => {
                          let newProd = { ...product };

                          // Almacenamos el valor temporal directamente
                          let newQuantity = value;
                          // dispatch(actions.updateCartProduct(newProd));

                          // Validar según el valor de decimal_stock
                          if (!newProd.decimal_stock) {
                            newQuantity = newQuantity === '' ? newQuantity : parseInt(newQuantity.replace(/-/g, ''));
                          } else {
                            newQuantity = newQuantity.replace(/,/g, '.').replace('-', '');
                          }

                          newProd.quantity = newQuantity;

                          if (newQuantity <= product.stock) {
                            dispatch(actions.updateCartProduct(newProd));
                          }
                        };

                        const onRemove = (index) => {
                          let _cart = [...cart];
                          _cart.splice(index,1);
                          dispatch(actions.fillCart(_cart));
                          if (_cart.length === 0) onClose();
                        }

                        return (
                          <div key={`cart-product-${index}`} className="flex flex-row justify-between items-center py-3 border-b border-b-gray-200">
                            <div className="flex flex-1 gap-2">
                              <div className="flex-none w-20 h-20 rounded overflow-hidden">
                                <img
                                  className="w-20 h-20 object-cover text-xs"
                                  src={process.env.REACT_APP_STORAGE + product.photo?.file}
                                  alt={product.name}
                                  onError={el => el.target.src = DefaultPhoto}
                                />
                              </div>

                              <div className="details">
                                <div className="flex flex-row justify-between">
                                  <span className="flex overflow-hidden text-sm text-gray-500 text-ellipsis mb-1">
                                    {product.name}
                                  </span>
                                  { show_prices && (product.type == SELL_TYPES.NORMAL || size_color != null) && (
                                    <>
                                      {!product?.applied_discounts?.length ? (
                                        <span className="price">
                                          { formatAmount(product.originalPrice, decimals) }
                                        </span>
                                      ) : (
                                        <span className="price space-x-3">
                                          <span className="line-through">
                                            { formatAmount(product.originalPrice, decimals) }
                                          </span>
                                          <span className="text-green-600">
                                            { formatAmount(product.finalPrice, decimals) }
                                          </span>
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>
                                {product?.applied_discounts?.map((x, xIdx) => (
                                  <div key={xIdx} className="text-xs text-right"><span className="text-green-600">-{ x.percentage }%</span> { x.name }</div>
                                ))}
                                {
                                  product.type == SELL_TYPES.SIZE_COLORS && (
                                    <React.Fragment>
                                      {
                                          [...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].length > 0 && (
                                          <select 
                                            value={ product.size_id }
                                            disabled={ true }
                                            style={{
                                              backgroundColor: '#e0e0e0',
                                              borderRadius: '5px',
                                              marginBottom: '10px',
                                              width: '150px',
                                              padding: '5px',
                                              fontSize: '12px'
                                            }}>
                                            <option value="">Seleccione</option>
                                            {
                                              [...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].map((_item) => {
                                                const size = sizes.find(i => i.id == _item);

                                                return (
                                                  <option
                                                    key={`size-${product.id}${_item}${new Date().getMilliseconds()}`}
                                                    value={ size?.id }
                                                  >
                                                    { size?.name }
                                                  </option>
                                                )
                                              })
                                            }
                                          </select>
                                        )
                                      }
                                      
                                      {
                                        [...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].length > 0 && (
                                            <div style={{ display: 'flex' }}>
                                              {
                                              [...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].map((i) => {
                                                  return (
                                                    <div
                                                      key={`color-${product.id}${i}${new Date().getMilliseconds()}`}
                                                      style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        borderRadius: '10px',
                                                        marginRight: '10px',
                                                        backgroundColor: colors?.find(item => item.id == i)?.hex,
                                                        borderWidth: 5,
                                                        borderColor: product.color_id == i ? '#00000066' : 'transparent'
                                                      }}></div>
                                                  )
                                                })
                                              }
                                            </div>
                                        )
                                      }
                                    </React.Fragment>
                                  )
                                }

                                {/* <div className="flex flex-row items-center justify-end gap-4">
                                  <span className="delete-btn" onClick={() => onRemove(index)}>Eliminar</span>
                                  <div className="qty">
                                    <button type="button" className="qty-btn" onClick={() => onUpdate(false)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m12" />
                                      </svg>
                                    </button>

                                    <span className="px-2">{ product.quantity }</span>

                                    <button type="button" className="qty-btn" onClick={() => onUpdate()}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12" />
                                      </svg>
                                    </button>
                                  </div>
                                </div> */}

                                <div className="flex flex-row items-center justify-end gap-4">
                                  <span className="delete-btn" onClick={() => onRemove(index)}>Eliminar</span>
                                  <div className="qty">
                                    <button type="button" className="qty-btn" onClick={() => onUpdate(false)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                        <path d="M6 11l10 0" />
                                      </svg>
                                    </button>

                                    <input
                                      className="px-2"
                                      type="number"
                                      value={product.quantity}
                                      onChange={e => onChangeManual(e.target.value)}
                                      onBlur={e => {
                                        if (e.target.value === '') onChangeManual('0');
                                      }}
                                      max={product?.stock}
                                    />

                                    <button type="button" className="qty-btn" onClick={() => onUpdate()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                      <path d="M11 6l0 10" />
                                      <path d="M6 11l10 0" />
                                    </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                    <div className="p-4 pt-0 mt-2 md:mt-0">
                      { show_prices && (
                        <div className="flex flex-row justify-between items-center mb-2">
                          <span className="text-gray-500 text-sm">Total a pagar</span>
                          <span className="text-green-600 text-2xl font-bold">{formatAmount(totals.total, decimals)}</span>
                        </div>
                      )}

                      <button
                        onClick={() => onSubmit()}
                        type="submit"
                        className={
                          'w-full focus:outline-none font-sm rounded-sm text-sm px-5 py-2.5 text-center' +
                          (form.tlf.length >= 10 ? ' bg-[#006DDB] text-white' : ' text-gray-400 bg-gray-200')
                        }
                      >
                        {loading ? (
                          <div className="flex justify-center">
                            <div role="status">
                              <svg aria-hidden="true" className="mr-2 w-5 h-5 text-gray-500 animate-spin fill-gray-900" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                              </svg>
                              <span className="sr-only">Cargando...</span>
                            </div>
                          </div>
                        ) : (
                          <span>Completar Pedido</span>
                        )}
                      </button>

                      <label className="block text-md font-bold text-bold mt-4 mb-2">Forma de despacho</label>
                      <div className="flex flex-row gap-4">
                        {dispatchTypes.map(x => (
                          <label
                            key={`dispatch-${x.value}`}
                            htmlFor={`radio-dispatch-${x.value}`}
                            className={'flex flex-1 items-center flex-col justify-center rounded-md border py-2 cursor-pointer' + (form.dispatch == x.value ? ' border-[#006DDB]' : '')}
                          >
                            <input
                              id={`radio-dispatch-${x.value}`}
                              type="radio"
                              checked={x.value === form.dispatch}
                              onClick={() => {
                                const isDelivery = String(dispatchTypes.find(d => d.value === x.value)?.label).toLowerCase() === 'delivery';
                                setForm(s => ({
                                  ...s,
                                  dispatch: x.value,
                                  errorDispatch: false,
                                  shipping_address: isDelivery && !s.shipping_address ? s.address : s.shipping_address,
                                }));
                              }}
                              onChange={() => {}}
                              className="hidden w-4 h-4 text-green-600 bg-gray-100 border-gray-300 focus:ring-transparent"
                            />
                            {x.label === 'Delivery' && (
                              <img src={DeliveryIcon} className="w-12 h-12" alt={x.label} />
                            )}
                            {x.label === 'Pick-Up' && (
                              <img src={PickUpIcon} className="w-12 h-12" alt={x.label} />
                            )}
                            <div className="text-xs font-medium text-gray-900">{ x.label }</div>
                          </label>
                        ))}
                      </div>

                      {form.errorDispatch && (
                        <span className="text-xs text-red-600 mt-2">Debe seleccionar la forma de despacho</span>
                      )}

                      <label className="block text-md font-bold text-bold mt-4 mb-2">Datos de la entrega</label>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-1">Nombre</label>
                      <input
                        id="name"
                        type="text"
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-sm focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB] block w-full p-2.5"
                        placeholder="Nombre"
                        value={form.name}
                        onChange={e => setForm(s => ({ ...s, name: e.target.value, errorName: false }))}
                      />
                      {form.errorName && (
                        <span className="text-xs text-red-600">Debe indicar su nombre</span>
                      )}

                      <label htmlFor="phone" className="block text-sm font-medium text-black mt-4 mb-1">Número de celular</label>
                      <div className="flex flex-row">
                        {/* <div className="relative inline-block">
                          <button
                            type="button"
                            onClick={() => setShowCodes(true)}
                            onBlur={() => setShowCodes(false)}
                            className="relative z-10 flex flex-row p-2 text-gray-700 bg-gray items-center border-l border-t border-b rounded-l-sm border-gray-300 focus:outline-none"
                          >
                            <span>{form.code}</span>
                            <svg className="w-5 h-5 text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </button>

                          {showCodes && (
                            <div className="absolute border right-0 z-20 w-32 py-2 mt-2 left-0 bg-white rounded-md shadow-xl">
                              <span
                                onClick={() => setForm(s => ({ ...s, code: '+58' }))}
                                className="block px-4 py-2 text-sm text-gray-600 capitalize transition-colors duration-200 transform cursor-pointer"
                              > +58 </span>
                            </div>
                          )}
                        </div> */}

                        <input
                          id="phone"
                          type="text"
                          className="bg-white border rounded-l-none border-gray-300 text-black text-sm rounded-sm focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB] block w-full p-2.5"
                          placeholder="Número de celular"
                          maxLength={11}
                          value={form.tlf}
                          onChange={e => setForm(s => ({ ...s, tlf: (e.target.value || '').replace(/\D/g, ''), errorPhone: false }))}
                        />
                      </div>
                      {form.errorPhone && (
                        <span className="text-xs text-red-600">El número de teléfono debe tener al menos 10 dígitos</span>
                      )}
                      {/* RIF Y DIRECCION */}

                      <label htmlFor="rif" className="block text-sm font-medium text-black mt-4 mb-1">{ getAdminCountryEquivalent(country_id).bothDni }</label>
                      <div className="flex flex-row">
                        <input
                          id="rif"
                          type="text"
                          className="bg-white border rounded-l-none border-gray-300 text-black text-sm rounded-sm focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB] block w-full p-2.5"
                          placeholder={ getAdminCountryEquivalent(country_id).bothDni }
                          onKeyDown={onlyRifChars}
                          value={form.document}
                          onChange={e => setForm(s => ({ ...s, document: (e.target.value || ''), errorDocument: false }))}
                        />
                      </div>
                      {form.errorDocument && (
                        <span className="text-xs text-red-600">El campo { getAdminCountryEquivalent(country_id).bothDni } es obligatorio</span>
                      )}

                      <label htmlFor="note" className="block text-sm font-medium text-black mt-4 mb-1">Dirección física</label>
                      <textarea
                        id="note"
                        rows="2"
                        className="block p-2.5 w-full text-sm text-black bg-white rounded-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB]"
                        value={form.address}
                        onChange={e => setForm(s => ({ ...s, address: e.target.value }))}
                      />

                      {isDelivery && (
                        <div>
                          <label htmlFor="address" className="block text-sm font-medium text-gray-900 mt-4 mb-2">Dirección de envío</label>
                          <input
                            id="address"
                            className="bg-white border rounded-l-none border-gray-300 text-gray-900 text-sm rounded-sm focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB] block w-full p-2.5"
                            placeholder="Dirección de envío"
                            autoComplete="address"
                            value={form.shipping_address}
                            onChange={e => setForm(s => ({ ...s, shipping_address: e.target.value, errorShippingAddress: false }))}
                          />
                        </div>
                      )}

                      <label htmlFor="note" className="block text-sm font-medium text-black mt-4 mb-1">Notas adicionales</label>
                      <textarea
                        id="note"
                        rows="2"
                        className="block p-2.5 w-full text-sm text-black bg-white rounded-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#006DDB] focus:border-[#006DDB]"
                        value={form.note}
                        onChange={e => setForm(s => ({ ...s, note: e.target.value }))}
                      />
                    </div>
                  </div>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default Checkout;